import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import toast from "react-hot-toast";
import DispatchSlip from "../services/DispatchSlip";
import { Button } from "@material-ui/core";
import { MdLocalPrintshop } from "react-icons/md";
import { Dropdown } from "primereact/dropdown";
import ShippersPackingService from "../services/ShippersPackingService";
import ReportService from "../services/ReportService";
import DispatchService from "../services/DispatchService";
import WarehouseMasterService from "../services/WarehouseMasterService";
import { useBrand } from "./../helper/BrandContext";

const DispatchReport = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const shippersPackingService = new ShippersPackingService();
  const reportService = new ReportService();
  const dispatchService = new DispatchService();
  const warehouseMasterService = new WarehouseMasterService();
  const surveyLink = useRef(null);
  const [warehouses, setWarehouses] = useState([]);
  const [userType, setUserType] = useState(sessionStorage.getItem("userType"));
  const [userWarehouse, setuserWarehouse] = useState(
    sessionStorage.getItem("wareHouseId")
  );
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "ReceivedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0,
    brandId: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: [],
    userType: 0
  });
  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);
  const dispatchSlip = new DispatchSlip();

  const handleButtonClick = async (row) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    let cartonId = row.dispatchId;
    shippersPackingService
      .shippersDetails(cartonId)
      .then((response) => {
        const data = response;
        setState((prevData) => ({
          ...prevData,
          shippersData: data,
          loading: false
        }));
      })
      .catch((error) => {
        console.error("API request failed:", error);
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  };

  const PrintDispatchData = (rowData) => {
    const editMode = () => {
      dispatchService
        .GetDispatchToPrint(rowData)
        .then((response) => {
          const data = response.responseData;
          dispatchSlip.Printpdf(data);
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
        })
        .catch((error) => {
          console.error("API request failed:", error);
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
        });
    };

    return (
      <Button
        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 
                rounded focus:outline-none focus:shadow-outline flex items-center"
        onClick={editMode}
      >
        <MdLocalPrintshop className="w-5 h-5 mr-2" />
      </Button>
    );
  };

  // Function to fetch options for the Warehouse dropdown based on UserType
  const fetchWarehouseOptions = async () => {
    try {
      warehouseMasterService.GetWarehouseDDL().then((response) => {
        if (response) {
          var items = response.responseData;
          if (userType == "0") {
            let newItem = { label: "All", value: "0" };
            items.unshift(newItem);
            setWarehouses(items);
            setTableRequest((prevData) => ({
              ...prevData,
              WareHouseId: "0"
            }));
          } else {
            items = items.filter((item) => item.value == userWarehouse);
            setWarehouses(items);
            setTableRequest((prevData) => ({
              ...prevData,
              WareHouseId: items[0].value
            }));
          }
        } else {
          toast.error(
            response.responseMessage || "Failed to fetch warehouse options"
          );
        }
      });
    } catch (error) {
      console.error("Failed to fetch warehouse options:", error);
      toast.error("Failed to fetch warehouse options");
    }
  };

  const handleFormChange = (e) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.WareHouseId = e.target.value;
    GetDispatchRpt();
  };

  function GetDispatchRpt() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    reportService
      .StockReceiveReport(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (
      (name === "FromDate" || name === "ToDate") &&
      !(value instanceof Date)
    ) {
      toast.error(
        `Please select a valid ${name === "FromDate" ? "from" : "to"} date.`
      );
      return;
    }

    if (name === "FromDate" && value > state.ToDate) {
      toast.error("From date must be less than to date.");
      return;
    }

    if (name === "ToDate" && value < state.FromDate) {
      toast.error("To date must be greater than from date.");
      return;
    }

    setState((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const FilterData = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
      first: 0
    }));

    tableRequest.PageSize = state.rows;
    tableRequest.PageNo = 1;
    tableRequest.First = 1;

    tableRequest.FromDate = state.FromDate.toLocaleDateString();
    tableRequest.ToDate = state.ToDate.toLocaleDateString();
    GetDispatchRpt();
  };

  const GetReportExport = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.PageSize = -1;
    reportService
      .StockReceiveReport(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const filteredData = data.responseData.map(
            ({ totalRows, ...rest }) => rest
          );
          setState((prevData) => ({
            ...prevData,
            allData: filteredData,
            loading: false
          }));
          tableRequest.PageSize = state.rows;
          setTriggerDownload(true);
          // Trigger the CSV download
        } else {
          setState((prevData) => ({
            ...prevData,
            allData: [],
            loading: false
          }));
          tableRequest.PageSize = state.rows;
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to export data");
      });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    //GetDispatchRpt();
  };

  const onIndexTemplate = (data, props) => {
    return state.first + props.rowIndex + 1;
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "DESC" : "ASC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetDispatchRpt();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    GetDispatchRpt();
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    var date = new Date();
    date.setDate(date.getDate() - 7);
    tableRequest.FromDate = date.toLocaleDateString();
    tableRequest.ToDate = new Date().toLocaleDateString();
    setState((prevData) => ({
      ...prevData,
      FromDate: date,
      ToDate: new Date()
    }));
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      fetchWarehouseOptions();
      GetDispatchRpt();
    }
  }, [brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="date-picker-container flex items-center md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Stock Receive Report
        </h1>
      </div>
      <div className="date-picker-container flex items-center md:mb-0">
        <Calendar
          value={state.FromDate || undefined}
          name="FromDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="From Date"
          className="p-inputtext-sm mr-2"
        />
        <Calendar
          value={state.ToDate || undefined}
          name="ToDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="To Date"
          className="p-inputtext-sm mr-2"
        />
        <Dropdown
          value={tableRequest.WareHouseId}
          onChange={handleFormChange}
          name="WareHouseId"
          options={warehouses}
          optionLabel="label"
          optionValue="value"
          filter
          placeholder="Select Plant/Warehouse"
          className="mr-2"
        />
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <button
          type="button"
          onClick={FilterData}
          className="ml-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
        <button
          target="_blank"
          disabled={!state.sales.length}
          className="ml-3 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={GetReportExport}
        >
          Export
        </button>
        <CSVLink
          hidden={true}
          data={state.allData}
          ref={surveyLink}
          filename={"Stock Receive Report.csv"}
        >
          Export
        </CSVLink>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <DataTable
              exportFilename="DeMapping Report"
              responsive={true}
              header={header}
              globalFilter={state.globalFilter}
              emptyMessage={state.emptyMessage}
              value={state.sales}
              paginator={true}
              rows={state.rows}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rowsPerPageOptions={[10, 50, 200, 500]}
              totalRecords={state.totalRecords}
              lazy={true}
              first={state.first}
              onPage={onPage}
              onSort={onSort}
              className="p-datatable-responsive"
            >
              <Column
                field="Index"
                header="Sr No"
                body={onIndexTemplate}
                style={{ width: "80px", "word-wrap": "break-word" }}
              />
              <Column
                field="cartonId"
                header="Carton Id"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="totalQty"
                header="Total Products"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="productName"
                header="Product SKU"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="batchNo"
                header="Batch No"
                sortable={false}
                style={{ width: "100px" }}
              />
              {/* <Column field="dispatchedBy" header="Packed At" sortable={false} style={{ width: '100px' }} /> */}
              {/* <Column field="dispatchedTo" header="Dispatched To" sortable={false} style={{ width: '100px' }} /> */}
              <Column
                field="receivedBy"
                header="Received By"
                sortable={false}
                style={{ width: "100px" }}
              />
              {/* <Column field="dispatchedDate" header="Packed Date" sortable={true} style={{ width: '100px' }} /> */}
              <Column
                field="receivedDate"
                header="Received Date"
                sortable={true}
                style={{ width: "100px" }}
              />
              <Column
                field="receivedLocation"
                header="Received Location"
                sortable={false}
                style={{ width: "100px" }}
              />
              {/* <Column body={PrintDispatchData} header="Action" sortable={false} style={{ width: '100px' }} /> */}
            </DataTable>
          </div>
        </div>
      )}
    </div>
  );
};

export default DispatchReport;
